export default class VideoCardTypes {
    public static SET_OPENTOK_DETAILS = 'SET_OPENTOK_DETAILS';
    public static SET_GCM_TOKEN = 'SET_GCM_TOKEN';
}
